/**
 * Big circular progress badge used on Campaign hero (e.g. "23 / 60 постов сегодня").
 * Pure SVG, no deps. Pass value (0..1).
 */
export function ProgressArc({
  value,
  size = 96,
  stroke = 8,
  label,
  sublabel,
}: {
  value: number;
  size?: number;
  stroke?: number;
  label: string;
  sublabel?: string;
}): JSX.Element {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const dash = c * Math.max(0, Math.min(1, value));
  return (
    <div className="relative inline-flex items-center justify-center">
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className="-rotate-90">
        <defs>
          <linearGradient id="arc-grad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#3D5BFF" />
            <stop offset="100%" stopColor="#7E96FF" />
          </linearGradient>
        </defs>
        <circle cx={size / 2} cy={size / 2} r={r} stroke="rgba(124,140,255,0.16)" strokeWidth={stroke} fill="none" />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          stroke="url(#arc-grad)"
          strokeWidth={stroke}
          fill="none"
          strokeDasharray={`${dash} ${c - dash}`}
          strokeLinecap="round"
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <div className="text-lg font-bold text-ink-50 leading-none">{label}</div>
        {sublabel && <div className="mt-0.5 text-2xs uppercase tracking-wider text-ink-500">{sublabel}</div>}
      </div>
    </div>
  );
}
